<template>
  <div ref="wrapper" uk-toggle="target: #custom-side-menu">
    <div class="tab" id="custom-sidebar-trigger">
       <span uk-icon="icon: menu"></span>
    </div>
  </div>

</template>

<script>
	export default {
		name: "SidePanelTab"
	}
</script>

<style lang="less" scoped>

  @import "../../assets/less/palette.less";


  .tab {
      cursor: pointer;
    position: fixed;
    height: 65px;
    width: 40px;
    top: 60%;
    left: -2px;//negative of border
    margin-top: -1em; //half of height

    background: @secondary-1;
    border: @secondary-2 1px solid;

    opacity: .9;

    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;

    display: flex;
    align-items: center;
    justify-content: center;


    &:hover {
      opacity: 1;
    }

    span {
      color: @secondary-2;
    }


  }


</style>
